import {
  CREATEPRODUCT,
  DELETEPRODUCT,
  IMPORT_PRODUCT,
  LISTOFPRODUCT,
  UPDATEPRODUCT,
  VIEWPRODUCT,
} from "./ApiRoutes";
import { authData } from "./services";

export const createProductApi = async (data: object) => {
  const response = await authData.post(CREATEPRODUCT, data);
  return response?.data;
};
export const updateProductApi = async (id: number, data: object) => {
  const response = await authData.put(`${UPDATEPRODUCT}${id}`, data);
  return response?.data;
};
export const listOfProductApi = async (data: object) => {
  const response = await authData.post(LISTOFPRODUCT, data);
  return response?.data;
};
export const viewProductApi = async (id: number) => {
  const response = await authData.get(`${VIEWPRODUCT}${id}`);
  return response?.data;
};
export const deleteProductApi = async (id: number) => {
  const response = await authData.delete(`${DELETEPRODUCT}${id}`);
  return response?.data;
};
export const importProductApi = async () => {
  const response = await authData.get(`${IMPORT_PRODUCT}`);
  return response?.data;
};

export const viewBatchProductApi = async (id: number,variantId: number) => {
  const response = await authData.get(`${VIEWPRODUCT}${id}/${variantId}`);
  return response?.data;
};